interface IConfigError {
  message: string | undefined;
  resource: string;
  errorCode?: string;
}
class ConfigError extends Error {
  resource: string;
  errorCode?: string;
  constructor({ message, resource, errorCode }: IConfigError) {
    super(message);
    this.name = 'ConfigException';
    this.resource = resource;
    this.errorCode = errorCode;
  }
}

export default ConfigError;
